import React from 'react';
import MobileHeader from './MobileHeader';
import BottomNav from './BottomNav';

const MobileLayout = ({ children, title = "Touba Rennes" }) => {
  return (
    <div className="min-h-screen bg-gray-50 pb-16 pt-14">
      <MobileHeader title={title} />

      <main className="safe-area-inset">
        {children}
      </main>

      <BottomNav />
    </div>
  );
};

export default MobileLayout;
